export default __webpack_public_path__ + "static/media/gallery_03.2aae8e40.jpg";